import _ from 'underscore';
import {
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useI18nContext } from '@bingads-webui/copilot-i18n';
import { IQuestion, searchQuestions } from '@bingads-webui/search-utils';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useOData } from './use-odata';

export function useQuestionsFromQuery(query: string, options: any) {
  const i18n = useI18nContext();
  const { scope } = useContext(ScopeContext);
  const [campaignNameMap, setCampaignNameMap] = useState<{ [key: string]: string }>({});
  const odata = useOData();

  const { isReportingInsightsEnabled, isTroubleshootingEnabled } = options;
  const { cid, aid, campaignId } = scope?.values || {};

  useEffect(() => {
    if (isReportingInsightsEnabled && cid && aid && campaignId) {
      if (!_.has(campaignNameMap, campaignId)) {
        odata?.get(`/Campaigns(${campaignId})?$select=Id,Name`).then((response: any) => {
          setCampaignNameMap((prev) => ({
            ...prev,
            [campaignId]: response?.data?.Name,
          }));
        });
      }
    }
  }, [
    aid,
    campaignId,
    campaignNameMap,
    cid,
    isReportingInsightsEnabled,
  ]);

  const questions = useMemo(() => {
    const originalQuestions = searchQuestions(query, i18n, true, { isTroubleshootingEnabled });
    if (isReportingInsightsEnabled && query === 'Campaigns') {
      if (cid && aid) {
        // replace the second question with a reporting insights question
        const insightsQuestion: IQuestion = {
          category: 'insight',
          text: i18n!.getString(_TL_('Summarize my account performance from the last {{rangeDays}} days.'), { rangeDays: '30' }),
          pluginName: 'Summarize',
          options: { omitDates: true },
        };

        const campaignName = campaignId && campaignNameMap[campaignId];
        if (campaignName) {
          insightsQuestion.text = i18n!.getString(_TL_('Summarize my "{{campaignName}}" performance from the last {{rangeDays}} days.'), { campaignName, rangeDays: '30' });
        }
        originalQuestions.splice(1, 1, insightsQuestion);
      }
    }
    return originalQuestions;
  }, [
    aid,
    campaignId,
    campaignNameMap,
    cid,
    i18n,
    isReportingInsightsEnabled,
    isTroubleshootingEnabled,
    query,
  ]);

  return questions;
}
